import { useCallback, useEffect, useRef, useState } from "react";

const getHorizontalPadding = (element: HTMLDivElement): number => {
  const computed = window.getComputedStyle(element);
  const paddingLeft = Number.parseFloat(computed.paddingLeft) || 0;
  const paddingRight = Number.parseFloat(computed.paddingRight) || 0;
  return paddingLeft + paddingRight;
};

/**
 * Measures the width of a container element and updates on resize.
 * Returns a ref to attach to the container and the current width in pixels.
 */
export const useContainerWidth = () => {
  const refContainer = useRef<HTMLDivElement>(null);
  const [stateWidth, setStateWidth] = useState(0);

  const updateWidth = useCallback(() => {
    if (refContainer.current) {
      const horizontalPadding = getHorizontalPadding(refContainer.current);
      setStateWidth(Math.max(0, refContainer.current.clientWidth - horizontalPadding));
    }
  }, []);

  useEffect(() => {
    updateWidth();

    const element = refContainer.current;
    if (!element) return;

    const observer = new ResizeObserver(() => {
      updateWidth();
    });
    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [updateWidth]);

  return { refContainer, width: stateWidth };
};
